<div class="category-filters-container">
  <ng-container *ngFor="let category of categoriesToShow; let i = index">
    <div
      class="category-filters-container__category-item"
      [ngClass]="{ 'category-filters-container__category-item-selected': selectedCategoryVM === category }"
    >
      <span (click)="onCategoryChange(category)">
        {{ category }}
      </span>
      <span *ngIf="selectedCategoryVM === category" (click)="onCategoryChange(undefined)">
        <ion-img [src]="crossIcon"></ion-img>
      </span>
    </div>
  </ng-container>
</div>
